import { render } from "./ProjectComponent.vue?vue&type=template&id=e585e302&ts=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__